import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Exception } from "../store/shared/http-request-state";

@Injectable({ providedIn: "root" })
export class ExceptionService {
  getException(httpErrorResponse: HttpErrorResponse) {
    return httpErrorResponse.error as Exception;
  }
}
